import styled, { css } from 'styled-components';

export const cssModalWrapper = css`
  top: 80px;
  background: none;

  ${({ theme }) => theme.media.mobile} {
    min-width: 100%;
    top: 0;
    border-radius: 0;
  }
`;

export const Wrapper = styled.div`
  width: 610px;
  height: 700px;
  background-color: #fff;
  border-radius: 0 4px 4px 4px;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
    height: 100vh;
    padding-top: 56px;
  }
`;

export const Title = styled.h2`
  display: none;

  ${({ theme }) => theme.media.mobile} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 56px;
    line-height: 56px;
    display: block;
    text-align: center;
    font-weight: bold;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
    z-index: 5;
  }
`;

export const Tabs = styled.div`
  display: flex;
  position: absolute;
  top: -36px;
  left: 0;
  width: 100%;

  ${({ theme }) => theme.media.mobile} {
    position: relative;
    top: 0;
  }
`;

export const TabsItem = styled.a<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 135px;
  margin-right: 5px;
  height: 36px;
  color: ${({ theme }) => theme.colors.gray800};
  background-color: #e9e9e9;
  border-radius: 4px 4px 0 0;
  font-size: 14px;

  ${({ $active }) =>
    $active &&
    css`
      background-color: #fff;
      font-weight: bold;
    `}

  ${({ theme }) => theme.media.mobile} {
    flex: 0 0 50%;
    height: 48px;
    margin-right: 0;
    line-height: 48px;
    border-radius: 0;
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 0 16px;
  overflow: hidden;

  ${({ theme }) => theme.media.mobile} {
    padding: 16px;
  }

  /* FIXME: Select컴포넌트 margin-top삭제 */
  > div {
    margin-top: 0;
  }
`;

export const Label = styled.label`
  margin-right: 16px;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.gray800};

  ${({ theme }) => theme.media.mobile} {
    flex: 0 0 110px;
    margin-right: 0;
  }
`;
